import { useEffect, useState } from 'react';
import axios from 'axios';
import * as AuthAPI from '@src/lib/api/auth';
import debounce from 'lodash/debounce';
import { isEmail, isStrongPassword } from 'validator';

const message = {
  initial: '',
  phone: '전화번호를 다시 확인해주세요.',
  validatePhone: '-을 제외한 숫자만 입력해 주세요.',
  reqPhone: '인증번호가 전송되었습니다.',
  correctCode: '인증되었습니다.',
  incorrectCode: '인증번호가 틀렸습니다. 다시 입력해주세요.',
  existPhone: '이미 등록 된 번호입니다.',
  expiredPhone: '전화번호 인증을 다시 진행해 주세요.',
  password: '영어 소문자와 숫자로 이루어진 10글자 이상으로 입력해주세요.',
  validateEmail: '이메일 형식을 확인해주세요.',
  insolvency: '전화번호를 다시 확인해주세요.',
  login: '이메일과 비밀번호를 다시 확인해 주세요.',
  existEmail: '이미 존재하는 이메일입니다.',
  passwordConfirm: '비밀번호가 일치하지 않습니다.',
  email: '정확한 서비스 제공을 위해 현재 사용중인 이메일을 기입해주세요.',
};

export const useForm = ({ initValues }) => {
  const [values, setValues] = useState(initValues);
  const [bottomText, setBottomText] = useState({
    email: message.email,
    password: message.password,
    passwordConfirm: message.initial,
    phoneNumber: message.initial,
    verify: message.initial,
    loginPassword: message.initial,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setValues({ ...values, [name]: value });
  };

  const handleCheckbox = (e) => {
    const { name, checked } = e.target;
    setValues({ ...values, [name]: checked });
  };

  const checkSMSRegistered = (data) => {
    if (data === 'exists') {
      setValues({
        ...values,
        phoneStatus: 'exists',
        SMSSent: true,
      });
    } else {
      setValues({
        ...values,
        phoneStatus: 'pending',
        SMSSent: true,
        verifyDisabled: false,
      });
    }
  };

  const checkSMSCodeVerification = (data) => {
    if (data === 'approved') {
      setValues({
        ...values,
        verifyStatus: 'success',
        // verified: true,
      });
      setBottomText({ ...bottomText, verify: message.correctCode });
    } else {
      setValues({
        ...values,
        verifyStatus: 'reject',
      });
      setBottomText({ ...bottomText, verify: message.incorrectCode });
    }
  };

  /* insolvency */
  // Handle insolvency agree all terms
  const handleInsolvencyAgreeAll = (e) => {
    if (e.target.checked) {
      setValues({
        ...values,
        ageConfirmation: true,
        legelengineTnC: true,
        privacyPolicy: true,
        caseAlertTnC: true,
        caseAlertPrivacyAgmt: true,
        caseAlertPrivacyThirdPartyAgmt: true,
        mktAgmt: true,
      });
    } else {
      setValues({
        ...values,
        ageConfirmation: false,
        legelengineTnC: false,
        privacyPolicy: false,
        caseAlertTnC: false,
        caseAlertPrivacyAgmt: false,
        caseAlertPrivacyThirdPartyAgmt: false,
        mktAgmt: false,
      });
    }
  };

  // Request verification code
  const handleInsolvencySMSRequest = async (e) => {
    e.preventDefault();

    // API call - request verification code
    try {
      const res = await AuthAPI.requestPhoneInsolvency({ phoneNumber: String(values.phoneNum) });
      if (res.status === 200) {
        checkSMSRegistered(res.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  // Check verification code
  const handleInsolvencyVerifyCode = async (e) => {
    e.preventDefault();

    // API call - check verification code
    try {
      const res = await AuthAPI.verifyPhoneInsolvency({
        phoneNumber: String(values.phoneNum),
        code: String(values.verificationCode),
      });
      if (res.status === 200) {
        checkSMSCodeVerification(res.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  // Submit data to db
  const handleInsolvencySubmit = async (e) => {
    const { name, caseNum, phoneNum, court, mktAgmt, verified, isFormReady } = values;
    e.preventDefault();

    // Submit only if all fields are filled and verified
    if (verified && isFormReady) {
      if (name !== '' && caseNum !== '') {
        // API call - add user
        const res = await axios.post(
          process.env.NEXT_PUBLIC_REST_API_URI_LEGACY + '/addInsolvencyUser',
          {
            phone: String(phoneNum),
            name: String(name),
            code: String(caseNum),
            court: String(court),
            mktAgreement: Number(mktAgmt),
            crossDomain: true,
          },
          {
            headers: {
              'Content-Type': 'application/json',
            },
          }
        );

        if (res.data === 'added') {
          window.location.replace('/insolvency_request/success');
        } else if (res.data === 'already exist') {
          alert(message.existPhone);
        } else if (res.data === 'not a verified phone') {
          alert(message.expiredPhone);
        } else if (res.data === 'expired') {
          alert(message.expiredPhone);
        }
      } else {
        alert(message.insolvency);
      }
    }
  };

  useEffect(() => {
    const {
      name,
      caseNum,
      phoneNum,
      verified,
      ageConfirmation,
      legelengineTnC,
      privacyPolicy,
      caseAlertTnC,
      caseAlertPrivacyAgmt,
      caseAlertPrivacyThirdPartyAgmt,
    } = values;

    // Validate if all fields are filled
    if (name && caseNum && phoneNum) {
      console.log('test111', values);
      if (
        verified *
          ageConfirmation *
          legelengineTnC *
          privacyPolicy *
          caseAlertTnC *
          caseAlertPrivacyAgmt *
          caseAlertPrivacyThirdPartyAgmt ===
        1
      ) {
        setValues({
          ...values,
          isFormReady: true,
        });
      } else {
        setValues({
          ...values,
          isFormReady: false,
        });
      }
    } else {
      setValues({
        ...values,
        isFormReady: false,
      });
    }
  }, [
    values.verified,
    values.ageConfirmation,
    values.legelengineTnC,
    values.privacyPolicy,
    values.caseAlertTnC,
    values.caseAlertPrivacyAgmt,
    values.caseAlertPrivacyThirdPartyAgmt,
    values.caseNum,
  ]);

  /* login Submit  */
  const handleLoginSubmit = async (e) => {
    const { email, password, prevUrl } = values;
    e.preventDefault();
    try {
      const res = await AuthAPI.localLogin({ email, password });

      // Succeed
      if (res.status === 200) {
        if (prevUrl.length > 0) {
          if (prevUrl.indexOf('token', 0) === -1) {
            window.location.replace(prevUrl);
          } else {
            window.location.replace('/user/profile/info');
          }
        } else {
          // for IE
          history.back();
        }
      }
    } catch (err) {
      setBottomText((prev) => ({ ...prev, loginPassword: message.login }));
      console.log(err);
      if (err.response?.status === 409) {
        const { key } = err.response.data;
        console.log(err);
      }
    }
  };

  /* sign up */

  const strongPasswordRule = {
    minLength: 10,
    minLowercase: 1,
    minUppercase: 0,
    minNumbers: 1,
    minSymbols: 0,
    returnScore: false,
    pointsPerUnique: 1,
    pointsPerRepeat: 0.5,
    pointsForContainingLower: 10,
    pointsForContainingUpper: 10,
    pointsForContainingNumber: 10,
    pointsForContainingSymbol: 10,
  };

  // Handle signup agree all terms
  const handleSignUpAgreeAll = (e) => {
    if (e.target.checked) {
      setValues({
        ...values,
        ageConfirmation: true,
        legelengineTnC: true,
        privacyPolicy: true,
        mktAgreement: true,
      });
    } else {
      setValues({
        ...values,
        ageConfirmation: false,
        legelengineTnC: false,
        privacyPolicy: false,
        mktAgreement: false,
      });
    }
  };

  const isNull = (target) => {
    if (target !== '' && target !== undefined && target !== null) {
      return false;
    }
    return true;
  };

  // Check if email exists
  const checkEmailExists = async (email) => {
    try {
      const result = await AuthAPI.checkEmailExists(email);
      if (result.data.data) {
        setValues((prev) => ({ ...prev, existEmail: result.data.data }));
        setBottomText((prev) => ({ ...prev, email: message.existEmail }));
      } else {
        setValues((prev) => ({ ...prev, existEmail: result.data.data }));
        setBottomText((prev) => ({ ...prev, email: message.email }));
      }
    } catch (e) {
      console.log(e);
    }
  };

  const passwordConfirmCheck = (value) => {
    if (values.passwordConfirm !== value) {
      setBottomText((prev) => ({ ...prev, passwordConfirm: message.passwordConfirm }));
    } else {
      setBottomText((prev) => ({ ...prev, passwordConfirm: message.initial }));
    }
  };

  // Validate form
  const validateSignup = {
    email: (value) => {
      if (!isEmail(value)) {
        setBottomText((prev) => ({ ...prev, email: message.email }));
        return false;
      } else {
        setBottomText((prev) => ({ ...prev, email: message.email }));
      }
      return true;
    },
    password: (value) => {
      if (!isStrongPassword(value, strongPasswordRule)) {
        setBottomText((prev) => ({ ...prev, password: message.password }));
        passwordConfirmCheck(value);
        return false;
      } else {
        passwordConfirmCheck(value);
        setBottomText((prev) => ({ ...prev, password: message.initial }));
      }
      return true;
    },
    passwordConfirm: (value) => {
      if (values.password !== value) {
        setBottomText((prev) => ({ ...prev, passwordConfirm: message.passwordConfirm }));
        return false;
      } else {
        setBottomText((prev) => ({ ...prev, passwordConfirm: message.initial }));
      }
      return true;
    },
    phoneNumber: (value) => {
      const regex = /[^0-9]+/g;
      if (value.search(regex) !== -1) {
        setBottomText((prev) => ({ ...prev, phoneNumber: message.validatePhone }));
        return false;
      } else {
        setBottomText((prev) => ({ ...prev, phoneNumber: message.initial }));
      }
      return true;
    },
  };

  const validateSignupForm = (name, value) => {
    if (name === 'password' || name === 'email' || name === 'passwordConfirm') {
      const validation = validateSignup[name](value);
      if (!validation) {
        return false;
      } else {
        return true;
      }
    }
  };

  const validatePhoneNum = (name, value) => {
    if (name === 'phoneNumber') {
      const validation = validateSignup[name](value);
      if (!validation) {
        return false;
      } else {
        return true;
      }
    }
    return true;
  };

  // Enable submit button
  const enableSignupSubmitButton = () => {
    if (!isNull(values.email) && !isNull(values.password) && !isNull(values.passwordConfirm)) {
      if (
        values.ageConfirmation &&
        values.legelengineTnC &&
        values.privacyPolicy &&
        !values.existEmail &&
        // values.verified &&
        validateSignup.email(values.email) &&
        validateSignup.password(values.password) &&
        validateSignup.passwordConfirm(values.passwordConfirm)
      ) {
        setValues({ ...values, isFormReady: true });
      } else {
        setValues({ ...values, isFormReady: false });
      }
    }
  };

  useEffect(() => {
    enableSignupSubmitButton();
  }, [
    values.email,
    values.password,
    values.passwordConfirm,
    values.ageConfirmation,
    values.legelengineTnC,
    values.privacyPolicy,
    values.existEmail,
  ]);

  // Handle input change
  const handleSignupChange = (e) => {
    const { name, value } = e.target;

    {
      name === 'email'
        ? setValues({ ...values, [name]: value, existEmail: false })
        : setValues({ ...values, [name]: value });
    }

    if (!validatePhoneNum(name, value)) return;

    if (!validateSignupForm(name, value)) return;

    if (name === 'email') {
      // Check if email is duplicated
      checkEmailExists(value);
    }
  };

  // Request verification code
  const handleSignupSMSRequest = async (e) => {
    e.preventDefault();
    const { phoneNumber } = values;

    // API call - request verification code
    try {
      const res = await AuthAPI.requestPhone({ phoneNumber });
      if (res.data !== '') {
        setBottomText((prev) => ({ ...prev, phoneNumber: message.reqPhone }));
        checkSMSRegistered(res.data);
      } else {
        setBottomText((prev) => ({ ...prev, phoneNumber: '국제 번호를 제외한 번호를 입력해주세요.' }));
      }
    } catch (error) {
      if (error.response.status === 409) {
        setBottomText((prev) => ({ ...prev, phoneNumber: message.existPhone }));
      } else {
        setBottomText((prev) => ({ ...prev, phoneNumber: message.phone }));
      }
      console.log(error);
    }
  };

  // Check verification code
  const handleSignupVerifyCode = async (e) => {
    e.preventDefault();
    const { phoneNumber, verificationCode } = values;

    // API call - check verification code\
    try {
      const res = await AuthAPI.verifyPhone({ phoneNumber, code: verificationCode });
      checkSMSCodeVerification(res.data.data);
    } catch (error) {}
  };

  const isEmptyOrSpaces = (str) => {
    if (str === null || str === undefined || str === '') {
      return null;
    }
    return str;
  };

  // Register user
  const handleSignupSubmit = async (e) => {
    e.preventDefault();
    const { email, password, occupation, company, phoneNumber } = values;

    let mktAgreement = 1;
    if (!values.mktAgreement) {
      mktAgreement = 0;
    }

    try {
      const res = await AuthAPI.localRegister({
        email,
        password,
        occupation,
        company,
        mktAgreement,
        phone: isEmptyOrSpaces(phoneNumber),
      });

      // Succeed
      if (res.status === 200) {
        window.location.replace('verify');
      }
    } catch (err) {
      console.log(err);
      // Duplicate
      if (err.response?.status === 409) {
        const { key } = err.response.data;
        setBottomText((prev) => ({ ...prev, email: message.existEmail }));
      }
    }
  };

  return {
    values,
    bottomText,
    handleChange,
    handleCheckbox,
    handleInsolvencySMSRequest,
    handleInsolvencyVerifyCode,
    handleInsolvencyAgreeAll,
    handleInsolvencySubmit,
    handleLoginSubmit,
    handleSignUpAgreeAll,
    isNull,
    checkEmailExists,
    validateSignup,
    enableSignupSubmitButton,
    handleSignupChange,
    handleSignupSMSRequest,
    handleSignupVerifyCode,
    handleSignupSubmit,
  };
};
